import { GzTabGroupWebComponent } from '../component/GzTabGroupWebComponent';
import { GzTabGroupEvents } from '../types/types';

export class GzTabChangeEvent extends Event {
  constructor(
    public readonly gzTabGroup: GzTabGroupWebComponent,
    public readonly previousTab: number,
    public readonly currentTab: number
  ) {
    super(GzTabGroupEvents.TAB_CHANGE);
  }
}
